import { lazy } from 'react';

const PaymentProcessRoutes = [
  {
    path: 'payment-process',
    component: lazy(() => import('views/payment-process')),
  },
];
export default PaymentProcessRoutes;
